
import React from 'react';
import { useTournament } from '@/contexts/TournamentContext';
import { TournamentLeaderboard } from '../shared/TournamentLeaderboard';

export const AmericanoLeaderboard: React.FC = () => {
  const { tournamentState } = useTournament();

  return (
    <TournamentLeaderboard
      players={tournamentState.americanoPlayers}
      currentRound={tournamentState.currentRound}
      isFinished={tournamentState.isFinished}
      tournamentType="americano"
    />
  );
};
